module.exports = __webpack_public_path__ + "media/images/emblems/Erlinsbach_SO-blason-42cffbf038e4d3801fb0501cd4e37cb3.png";